import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import "./FollowerViewItem.css";
import { getImage } from "../../utilities/storageOperations/downloadURL";

export default function FollowerViewItem(props) {
  const [imageUrl, setimageUrl] = useState("");

  useEffect(() => {
    getPicture(props.Key);
  }, []);

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      // var key = imageURLSplit(url);
      getImage(url)
        .then((result) => {
          setimageUrl(result);
        })
        .catch(() => {
        });
    } else {
    }
  };

  return (
    <Row className="fv_container" >
      <Col
        span={4}
        style={{
          // display: "flex",
          // alignItems: "center",
          // justifyContent: "center",
        }}
      >
        <div className="img_item_fv">
          {props.Key !== null && props.Key?.split("/")?.pop() !== "no-pic.png" ? (
            <img
              // src={imageUrl} 
              style={{ width: "100%", height: "100%" }}
              src={`${process.env.REACT_APP_S3_URL}${props.Key?.charAt(0) !== "/" ? '/' : ""}${props.Key}`}
              // src={imageUrl}
            />
          ) : (
            <h3 className="profileNameLetter">{props?.name?.split("")[0]}</h3>
          )}
        </div>
      </Col>
      <Col span={18} className="item_inner_container_fv">
        <Row className="item_inner_row-container">
          <Col>
            <p className="text_fv text_bold_fv">{props.name ? props?.name :'Username'}</p>
            <p className="text_fv fv_light_text">
            {props.location ? props.location : "Location not found"}
          </p>
          </Col>
          <Col>
            {props.views !== "" ? (
              <p className="text_fv">{`viewed ${props.views} ${props.views > 1 ? " times" : " time"}`}</p>
            ) : null}
          </Col>
        </Row>
        {/* <Row style={{ display: "flex", alignItems: "center" }}>
          
        </Row> */}
      </Col>
    </Row>
  );
}
